import React, { useState, useEffect } from "react";
import { getNotesData, addData, updateData } from "../../../lib/pagenotes";
import TextEditor from "../../ui/editor";
import parse from 'html-react-parser'

export default function PageNotes({ type, studentId, instructorId, pageName }) {
	pageName = 'Task'

	const [studentNote, setStudentNote] = useState()
	const [instructorNote, setInstructorNote] = useState()
	const [status, setStatus] = useState('')
	const [recId, setRecId] = useState()
	const [show, setShow] = useState(false)

	const handleSubmitInstructor = async (e) => {
		e.preventDefault()
		if (status == 'Add') {
			await addData({
				page: pageName,
				studentId: studentId,
				studentNote: studentNote,
				instructorId: instructorId,
				instructorNote: instructorNote
			})
			setStatus('Update')
		} else {
			await updateData({
				id: recId,
				page: pageName,
				studentId: studentId,
				studentNote: studentNote,
				instructorId: instructorId,
				instructorNote: instructorNote
			})
		}
		setShow(true)
	}

	async function RecordCheck() {
		const sdata = await getNotesData(studentId, instructorId, pageName)

		if (sdata.length === 0) {
			setStatus('Add')
		} else {
			setStatus('Update')
			setRecId(sdata[0].id)
			GetNotes()
		}
	}

	async function GetNotes() {
		const sdata = await getNotesData(studentId, instructorId, pageName)
		setStudentNote(sdata[0].studentNote)
		setInstructorNote(sdata[0].instructorNote)
		setRecId(sdata[0].id)
	}

	useEffect(() => {
		RecordCheck()
		setShow(false)
	}, [])

	const messages = () => {
		return (
			<div className="alert alert-success alert-dismissible fade show" role="alert">
				<strong>Data Updated...</strong>
				<button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={(e) => setShow(false)}></button>
			</div>
		)
	}

	return (
		<div className="settings-widget">
			<div className="settings-inner-blk p-0">
				<div className="">{show ? messages() : ''}</div>
				<div className="py-2 px-4">
					<div className="personal-info-head">
						<h4>
							Note{' '}
							<button
								type="button"
								className="btn btn-outline-info"
								data-bs-toggle="collapse"
								data-bs-target="#collapseText"
								aria-expanded="false"
								aria-controls="collapseText"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="15"
									height="15"
									fill="currentColor"
									className="bi bi-chevron-double-down"
									viewBox="0 0 16 16"
								>
									<path
										fillRule="evenodd"
										d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
									/>
									<path
										fillRule="evenodd"
										d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
									/>
								</svg>
							</button>
						</h4>
					</div>
					<div className="pb-0 collapse" id="collapseText">
						<div className="settings-referral-blk course-instruct-blk table-responsive">
							{type === 'Instructor' ? (
								<form method="post" onSubmit={handleSubmitInstructor}>
									<div className="col-12">
										<div className="form-group">
											<div id="editor">
												<TextEditor value={instructorNote} setValue={setInstructorNote} />
											</div>
										</div>
									</div>
									<div className="update-profile d-flex justify-content-between">
										<button type="submit" className="btn btn-primary">
											Note Update
										</button>
									</div>
								</form>
							) : (
								<div className="col-12">
									<div className="form-group">
										<div className="p-3 bg-light rounded">{instructorNote ? parse(instructorNote) : 'No notes available'}</div>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
